import { render, staticRenderFns } from "./MonthlyPTPTNSubmissionRecordNew.vue?vue&type=template&id=0a826f92"
import script from "./MonthlyPTPTNSubmissionRecordNew.vue?vue&type=script&lang=js"
export * from "./MonthlyPTPTNSubmissionRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports